import { useState } from 'react';

export type TypeLayout = 'col' | 'row';

const useListLayout = () => {
  const [type, setType] = useState<TypeLayout>('col');

  const changeTypeLayout = (type: TypeLayout) => {
    setType(type);
  };

  return { type, changeTypeLayout };
};

export default useListLayout;
